import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "table table-hover align-middle" }
const _hoisted_2 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "Cnk", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePlaceholderTable = _resolveComponent("BasePlaceholderTable")!
  const _component_CatalogProductsOverviewTableItem = _resolveComponent("CatalogProductsOverviewTableItem")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('priceInclVat')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('discount')), 1),
        (_ctx.AbilityContext.isAuthorizedForFeature('ADVANCED_MGMT_CUSTOMER_CATALOG_PRODUCTS'))
          ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(_ctx.$t('customerSort')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_ctx.ui.isNotReady())
        ? (_openBlock(), _createBlock(_component_BasePlaceholderTable, {
            key: 0,
            "n-cols": 7
          }))
        : (_ctx.ui.isReady() && !_ctx.hasProducts)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
              _createElementVNode("td", {
                colspan: _ctx.colCount,
                class: "fw-bold small text-uppercase text-muted"
              }, _toDisplayString(_ctx.$t('noResults')), 9, _hoisted_8)
            ]))
          : (_ctx.ui.isReady() && _ctx.hasProducts)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.productsOverview.results, (product, index) => {
                return (_openBlock(), _createBlock(_component_CatalogProductsOverviewTableItem, {
                  key: product.id,
                  class: "position-relative",
                  onlyProductsWithCustomWeights: _ctx.onlyProductsWithCustomWeights,
                  product: product,
                  draggable: true,
                  onDragstart: ($event: any) => (_ctx.dragStart($event, index)),
                  onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (_ctx.drop($event, index)),
                  onDataChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dataChanged')))
                }, null, 8, ["onlyProductsWithCustomWeights", "product", "onDragstart", "onDrop"]))
              }), 128))
            : _createCommentVNode("", true)
    ])
  ]))
}